export default __webpack_public_path__ + "static/corporativo-icon-two-11b22e10b233207980998e6d9dd110e6.svg";